import React, { Component, useContext, useEffect, useState } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Select from "react-select";
import { ManufacturingTask } from "./ManufacturingTask";
import { ManufacturingRawMaterials } from "./ManufacturingRawMaterials";
import { FaRegFilePdf } from "react-icons/fa6";

import {
  BsFillPencilFill as BsPencil,
  BsFillPrinterFill,
} from "react-icons/bs";
import Swal from "sweetalert2";
import axios from "axios";

import {
  OverlayTrigger,
  Alert,
  FloatingLabel,
  Tabs,
  Tab,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
  Card,
  Spinner,
} from "react-bootstrap";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  ChartTooltip,
  Legend
);

// ---------- ManufacturingRequestOrders (updated with Analytics) ----------
export class ManufacturingRequestOrders extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      manufacturingrequestorders: [],
      rawmaterialwarehouse: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      rawMaterialsInventory: [],
      firstload: false,
      users: [],

      // analytics modal state
      analyticsOpen: false,
    };
  }
  GetUsers = () => {
    const config = {
      headers: { Authorization: `Bearer ${this.context.userData.bearertoken}` },
    };
    fetch(
      process.env.REACT_APP_API +
        "AdminUsers/GetStoreUserAccounts/" +
        this.context.storeId
      // config
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({
            //users: data.filter((f) => f.storeRoleId != 1),
            users: data,
          });
        }
      })
      .catch((error) => {
        alert("Session Timeout! Signout and Signin again!");
      });
  };
  GetRawMaterialWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialwarehouse: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsInventories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawMaterialsInventory: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetManufacturingRequestOrders = () => {
    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/GetManufacturingRequestOrders/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ manufacturingrequestorders: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ manufacturingrequestorders: [] }, () => {
      this.GetManufacturingRequestOrders();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    if (this.state.firstload == false) {
      this.state.firstload = true;
      this.GetManufacturingRequestOrders();
      this.GetRawMaterialsInventories();
      this.GetUsers();
      this.GetRawMaterialWarehouses();
    }
    window.scrollTo(0, 0);
  };

  // ------------------- new analytics open/close -------------------
  openAnalytics = () => this.setState({ analyticsOpen: true });
  closeAnalytics = () => this.setState({ analyticsOpen: false });

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3>Production Work Orders&nbsp;</h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    // onClick={() => this.handleAddSupplier()}
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    Add
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh
                  </Button>
                  &nbsp;
                  {/* Analytics button - opens the new component modal */}
                  <Button
                    variant="outline-primary"
                    onClick={this.openAnalytics}
                    title="Open Manufacturing Analytics"
                  >
                    Analytics
                  </Button>
                  &nbsp;
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          {this.state.addModalShow === true ? (
            <ManufacturingAddOrEditModal
              show={this.state.addModalShow}
              Type="Add"
              onHide={this.addModalClose}
              rawMaterialsInventory={this.state.rawMaterialsInventory}
              rawmaterialwarehouse={this.state.rawmaterialwarehouse}
              users={this.state.users}
            />
          ) : null}
          <div>
            <Tabs
              id="controlled-tab-example"
              activeKey={this.state.key}
              onSelect={(k) => this.setState({ key: k })}
              className="mb-3 bg-light fw-bold"
              fill
              style={{ fontSize: "16px", color: "yellow" }}
            >
              <Tab
                eventKey="NewRequest"
                title={
                  "1.New (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 1
                  ).length +
                  ")"
                }
              >
                <ManufacturingRequestOrdersTable
                  status="1"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
              <Tab
                eventKey="Making"
                title={
                  "2.Making (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 2
                  ).length +
                  ")"
                }
                className=""
              >
                <ManufacturingRequestOrdersTable
                  status="2"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
              <Tab
                eventKey="QualityCheck"
                title={
                  "3.QC (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 3
                  ).length +
                  ")"
                }
                className=""
              >
                <ManufacturingRequestOrdersTable
                  status="3"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
              <Tab
                eventKey="ReadyToShip"
                title={
                  "4.To WH (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 4
                  ).length +
                  ")"
                }
                className=""
              >
                <ManufacturingRequestOrdersTable
                  status="4"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
              <Tab
                eventKey="FgToInventory"
                title={
                  "5.FG to Inventory (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 5
                  ).length +
                  ")"
                }
              >
                <ManufacturingRequestOrdersTable
                  status="5"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
              <Tab
                eventKey="Closed"
                title={
                  "6.Closed (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 6
                  ).length +
                  ")"
                }
              >
                <ManufacturingRequestOrdersTable
                  status="6"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
              <Tab
                eventKey="Cancelled"
                title={
                  "7.Cancelled (" +
                  this.state.manufacturingrequestorders.filter(
                    (f) => f.statusId == 7
                  ).length +
                  ")"
                }
              >
                <ManufacturingRequestOrdersTable
                  status="7"
                  OnDeleted={this.OnDeleted}
                  users={this.state.users}
                  manufacturingrequestorders={
                    this.state.manufacturingrequestorders
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  Refresh={this.OnRefreshButtonClick}
                ></ManufacturingRequestOrdersTable>
              </Tab>
            </Tabs>
          </div>
        </div>

        {/* Analytics Modal component */}
        <ManufacturingDashboard
          show={this.state.analyticsOpen}
          onHide={this.closeAnalytics}
        />
      </>
    );
  }
}

export class ManufacturingRequestOrdersTable extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Table hover border striped className="px-0 bg-white ">
          {window.innerWidth > 900 ? (
            <>
              <thead className="">
                <tr className="text-start text-black bg-white border">
                  <th></th>
                  <th width="10%">Created</th>
                  <th width="10%">Work Order No</th>
                  <th width="30%">Work Order Name</th>
                  {/* <th width="10%">Qty</th> */}
                  <th width="10%">Status</th>
                  <th width="10%">Plant / WH</th>
                  <th width="10%">Created By</th>
                  <th width="10%">Assigned To</th>
                  <th width="10%" className="text-end">
                    Options
                  </th>
                </tr>
              </thead>
            </>
          ) : (
            <></>
          )}

          <tbody className="text-primary border">
            {this.props.manufacturingrequestorders
              .filter((f) => f.statusId == this.props.status)
              .sort((a, b) => (a.created > b.created ? 1 : -1))
              .map((request, i) => (
                <EditManufacturingInline
                  index={i}
                  status={this.props.status}
                  manufacturingRequest={request}
                  OnDeleted={this.props.OnDeleted}
                  users={this.props.users}
                  rawMaterialsInventory={this.props.rawMaterialsInventory}
                  rawmaterialwarehouse={this.props.rawmaterialwarehouse}
                  Refresh={this.props.Refresh}
                ></EditManufacturingInline>
              ))}
          </tbody>
        </Table>
      </>
    );
  }
}

export class EditManufacturingInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  GetWarehouseName = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  OnDelete = () => {};

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {
      this.props.Refresh();
    });
  };
  GetProductNameById = (id) => {
    var result = this.context.prods.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    else return "";
  };
  GetStatusNameById = (id) => {
    var result = this.context.manufacturingStatusTypes.filter(
      (f) => f.id == id
    );
    if (result.length > 0) return result[0].name;
    else return "";
  };
  GetUserNameById = (id) => {
    var result = this.props.users.filter((f) => f.id == id);
    if (result.length > 0) return result[0].emailId;
    else return "";
  };
  componentDidMount = () => {
    this.setState({ supplier: this.props.supplier });
  };

  OnDelete = (order) => {
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/DeleteManufacturingRequestOrder/" +
        order.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          alert("Not deleted. try again later!");
          return;
        }

        this.props.Refresh();
      })
      .catch((error) => {
        alert("OnDelete Failed" + error);
      });
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <ManufacturingAddOrEditModal
            show={this.state.editModalShow}
            status={this.props.status}
            onHide={this.editModalClose}
            manufacturingRequest={this.props.manufacturingRequest}
            Type="Edit"
            users={this.props.users}
            rawMaterialsInventory={this.props.rawMaterialsInventory}
            rawmaterialwarehouse={this.props.rawmaterialwarehouse}
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        {/** DESKTOP ROW (unchanged look, available on md+) **/}
        <tr
          className="d-none d-md-table-row text-start align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
          onClick={(e) => {
            this.OnEditButtonClick(e);
          }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{this.props.index + 1}</td>
          <td className="text-start ">
            {this.context.GetInDateFormat(
              new Date(this.props.manufacturingRequest.created)
            )}
          </td>
          <td className="text-start ">
            <b>{this.props.manufacturingRequest.pmrNo}</b>
          </td>
          <td className="text-start ">
            {this.props.manufacturingRequest.productName}
          </td>
          {/* <td className="text-start ">{this.props.manufacturingRequest.qty}</td> */}
          <td className="text-start ">
            {this.GetStatusNameById(this.props.manufacturingRequest.statusId)}
          </td>
          <td className="text-start ">
            {this.GetWarehouseName(this.props.manufacturingRequest.warehouseId)}
          </td>
          <td className="text-start ">
            {this.GetUserNameById(this.props.manufacturingRequest.createdBy)}
          </td>
          <td className="text-start ">
            {this.GetUserNameById(this.props.manufacturingRequest.assignedTo)}
          </td>

          <td className="col-md-2 text-end align-middle ">
            <div className="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  className="rounded-circle"
                  variant="warning"
                  onClick={(e) => {
                    e.stopPropagation(); // <-- prevent row click
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="16" />
                </Button>
              </OverlayTrigger>
              &nbsp;&nbsp;
              <OverlayTrigger overlay={<Tooltip>Delete!</Tooltip>}>
                <Button
                  className="rounded-circle"
                  variant="danger"
                  hidden={
                    this.context.UserRoles.PRODUCTADMIN !=
                    this.context.userData.roleId
                  }
                  onClick={(e) => {
                    e.stopPropagation(); // <-- prevent row click
                    this.OnDelete(this.props.manufacturingRequest);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fillRule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>

        {/** MOBILE ROW (d-table-row on xs/sm, hidden on md+) - compact 3-column layout **/}
        <tr
          className="d-table-row d-md-none text-start bg-white"
          style={{ fontSize: "12px" }}
          onClick={(e) => {
            this.OnEditButtonClick(e); // tapping anywhere opens edit (same behavior as desktop)
          }}
        >
          <td colSpan="99" style={{ padding: 8 }}>
            <div className="container-fluid p-1">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "8px 12px",
                  alignItems: "start",
                }}
                role="button"
              >
                {/* COL 1: Date / PMR / Product */}
                <div>
                  <div
                    style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}
                  >
                    {this.props.index + 1}.{" "}
                    {this.props.manufacturingRequest.productName}
                  </div>

                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>Date:</strong>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    {this.context.GetInDateFormat(
                      new Date(this.props.manufacturingRequest.created)
                    )}
                  </div>

                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>PMR No:</strong>
                  </div>
                  <div>
                    <b>{this.props.manufacturingRequest.pmrNo}</b>
                  </div>
                </div>

                {/* COL 2: Qty / Status / Warehouse */}
                <div>
                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>Qty:</strong>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    {this.props.manufacturingRequest.qty}
                  </div>

                  {/* compute local variable so it's easy to debug */}
                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>Status:</strong>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    {this.GetStatusNameById(
                      this.props.manufacturingRequest.statusId
                    )}
                  </div>

                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>Warehouse:</strong>
                  </div>
                  <div>
                    {this.GetWarehouseName(
                      this.props.manufacturingRequest.warehouseId
                    )}
                  </div>
                </div>

                {/* COL 3: CreatedBy / AssignedTo / Actions */}
                <div>
                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>Created By:</strong>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    {this.GetUserNameById(
                      this.props.manufacturingRequest.createdBy
                    )}
                  </div>

                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    <strong>Assigned To:</strong>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    {this.GetUserNameById(
                      this.props.manufacturingRequest.assignedTo
                    )}
                  </div>

                  <div className="d-flex justify-content-center gap-2 mt-2">
                    <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                      <Button
                        className="rounded-circle p-1"
                        variant="warning"
                        onClick={(e) => {
                          e.stopPropagation(); // prevents row click from firing
                          this.OnEditButtonClick(e);
                        }}
                      >
                        <BsFillPencilFill size="14" />
                      </Button>
                    </OverlayTrigger>

                    <OverlayTrigger overlay={<Tooltip>Delete!</Tooltip>}>
                      <Button
                        className="rounded-circle p-1"
                        variant="danger"
                        hidden={
                          this.context.UserRoles.PRODUCTADMIN !=
                          this.context.userData.roleId
                        }
                        onClick={(e) => {
                          e.stopPropagation(); // prevents row click
                          this.OnDelete(this.props.manufacturingRequest);
                        }}
                      >
                        X
                      </Button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  }
}
export class ManufacturingAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      manufacturingRequest: {
        productId: "",
        qty: "1",
        customDetails: "",
        statusId: "1",
        statusWofklowDescription: "",
        createdBy: "",
        assignedTo: "",
      },
      previousStatusId:
        this.props.Type == "Edit"
          ? this.props.manufacturingRequest.statusId
          : "",
      firstload: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      productNames: [],

      manufacturingTasks: [],
      showManufacturingTaskModal: false,
      editManufacturingTaskRow: 0,
      editManufacturingTaskModalShow: false,

      manufacturingRawMaterials: [],
      showManufacturingRawMaterialModal: false,
      editManufacturingRawMaterialRow: 0,
      editManufacturingRawMaterialModalShow: false,
      nextStatusList: [{ state: "NewOrder", value: "1" }],
      purchaseOrderItems: [],
      productionFinishedGoodItems: [], // <-- NEW

      salesOrders: [],
      selectedSalesOrderId: "",
      loadingSalesOrders: false,
      salesOrderLoaded: false, // <- new: prevents changing/reloading after load
    };
  }

  generateGuid() {
    // Generates a pseudo-GUID (RFC4122 v4 format)
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  GetSalesOrders = async () => {
    try {
      this.setState({ loadingSalesOrders: true });
      const res = await fetch(
        `${process.env.REACT_APP_API}SalesOrder/GetSalesOrders/${this.context.storeId}`
      );
      const data = await res.json();
      const salesOrders = Array.isArray(data) ? data : [];

      // Set salesOrders first
      this.setState({ salesOrders }, () => {
        // If we're editing and the manufacturingRequest already has a SalesOrderId, select it
        if (
          this.props.Type === "Edit" &&
          this.props.manufacturingRequest?.salesOrderId
        ) {
          // manufacturingRequest.salesOrderId is a GUID (object on backend) — convert to string for matching
          const soId = String(this.props.manufacturingRequest.salesOrderId);
          // Ensure the id exists in returned salesOrders before selecting
          const found = (this.state.salesOrders || []).some(
            (s) => String(s.Id || s.id) === soId
          );
          if (found) {
            this.setState({
              selectedSalesOrderId: soId,
              salesOrderLoaded: true, // lock it so user can't change/re-load
            });
          } else {
            // still set selected id (even if not in list) so UI reflects value; do not lock
            this.setState({ selectedSalesOrderId: soId });
          }
        }
      });
    } catch (err) {
      console.error("Failed loading sales orders", err);
      this.setState({ salesOrders: [] });
    } finally {
      this.setState({ loadingSalesOrders: false });
    }
  };

  /* ------------------ NEW: load a single sales order with items ------------------ */
  LoadSalesOrderItems = async (salesOrderId) => {
    if (!salesOrderId) return;

    try {
      this.ShowLoadSpinner();
      const res = await fetch(
        `${process.env.REACT_APP_API}SalesOrder/GetSalesOrderById/${salesOrderId}`
      );
      const data = await res.json();

      const items = data?.salesOrderItems || [];

      const baseWarehouseId =
        this.state.manufacturingRequest.warehouseId ||
        (this.props.rawmaterialwarehouse && this.props.rawmaterialwarehouse[0]
          ? this.props.rawmaterialwarehouse[0].id
          : "");

      const mappedFGs = items.map((it, idx) => {
        const productId = it.productId || null;
        const qty =
          it.piecesOrdered != null && it.piecesOrdered !== 0
            ? it.piecesOrdered
            : it.qtyOrdered || 0;

        let productName =
          it.itemName ||
          (productId ? this.GetProductName(productId) : "") ||
          "";

        if (!productName && productId) {
          const prod = (this.context.prods || []).find(
            (p) => p.id === productId
          );
          if (prod) productName = prod.name;
        }

        return {
          id: it.id || this.generateGuid(),
          itemId: productId,
          productId,
          productName,
          qty,
          unit: it.unit || "",
          details: it.notes || "",
          seqNo: idx + 1,
          warehouseId: baseWarehouseId,
          addedToStock: false,
          rate: it.rate || null,
        };
      });

      const existingTasks = Array.isArray(this.state.manufacturingTasks)
        ? [...this.state.manufacturingTasks]
        : [];
      const startSeq = existingTasks.length + 1;

      const mappedTasks = items.map((it, idx) => {
        const descParts = [];
        // if (it.thickness != null) descParts.push(`Thickness: ${it.thickness}`);
        // if (it.width != null) descParts.push(`Width: ${it.width}`);
        // if (it.length != null) descParts.push(`Length: ${it.length}`);
        if (it.piecesOrdered != null)
          descParts.push(`PiecesOrdered: ${it.piecesOrdered}`);
        // if (it.qtyOrdered != null)
        //   descParts.push(`QtyOrdered: ${it.qtyOrdered}`);
        if (it.notes) descParts.push(`Notes: ${it.notes}`);

        return {
          id: it.id || this.generateGuid(),
          taskName: it.itemName || `Item ${idx + 1}`,
          taskDescription: descParts.join(" | "),
          piecesOrdered: it.piecesOrdered || 0,
          qtyOrdered: it.qtyOrdered || 0,
          thickness: it.thickness,
          width: it.width,
          length: it.length,
          assignedTo: null,
          statusId: 1,
          seqNo: startSeq + idx,
        };
      });

      // Append the mapped arrays to state and lock the sales order (so it can't be changed)
      this.setState(
        (prev) => ({
          productionFinishedGoodItems: [
            ...(prev.productionFinishedGoodItems || []),
            ...mappedFGs,
          ],
          manufacturingTasks: [
            ...(prev.manufacturingTasks || []),
            ...mappedTasks,
          ],
          salesOrderLoaded: true, // <- lock so user cannot change or reload
        }),
        () => {
          Swal.fire({
            title: "Sales Order Loaded",
            text: `${mappedFGs.length} finished-good item(s) and ${mappedTasks.length} work order item(s) loaded.`,
            icon: "success",
            timer: 1400,
            showConfirmButton: false,
          });
        }
      );
    } catch (err) {
      console.error("LoadSalesOrderItems error", err);
      Swal.fire({
        title: "Error",
        text: "Failed to load sales order items",
        icon: "error",
      });
    } finally {
      this.HideLoadSpinner();
    }
  };

  GetProductInfo = (row) => {
    var result = row.itemName;

    if (row.batchId) {
      result +=
        this.context.store.businessTypeId ==
        this.context.BusinessTypes.STEELTRADERS
          ? " CoilId:" + row.batchId
          : " BatchId:" + row.batchId;
    }
    if (row?.remarks)
      result +=
        this.context.store.businessTypeId ==
        this.context.BusinessTypes.STEELTRADERS
          ? ` ${row.remarks}`
          : ` ${row.remarks}`;

    return result;
  };

  GetTotalOfPurchaseOrderWithoutTax = (rawMaterialsPurchaseOrderItems) => {
    let sum = 0;
    rawMaterialsPurchaseOrderItems.forEach((v) => {
      sum += v.rate * v.qty;
    });

    return sum;
  };

  GetTotalOfPurchaseOrderTaxAmount = (rawMaterialsPurchaseOrderItems) => {
    let sum = 0;
    rawMaterialsPurchaseOrderItems.forEach((v) => {
      sum += (v.rate * v.qty * v.tax) / 100;
    });

    return sum;
  };

  GetTotalOfPurchaseOrder = (purchaseOrderItems) => {
    let sum = 0;
    purchaseOrderItems.forEach((v) => {
      sum += this.context.ReturnwithTax(v.rate, v.qty, v.discount, v.tax);
    });

    return Math.round(sum);
  };

  LoadNextStatus = () => {
    if (this.state.manufacturingRequest.statusId == 1) {
      this.setState({
        nextStatusList: [
          { state: "NewOrder", value: "1" },
          { state: "Making-In-Progress", value: "2" },
          { state: "Cancel", value: "7" },
        ],
      });
    } else if (this.state.manufacturingRequest.statusId == 2) {
      this.setState({
        nextStatusList: [
          { state: "Making-In-Progress", value: "2" },
          { state: "Making-Complete", value: "3" },
          { state: "Cancel", value: "7" },
        ],
      });
    } else if (this.state.manufacturingRequest.statusId == 3) {
      this.setState({
        nextStatusList: [
          { state: "Making-Complete", value: "3" },
          { state: "Quality-Passed", value: "4" },
          { state: "Quality-Failed", value: "2" },
          { state: "Cancel", value: "7" },
        ],
      });
    } else if (this.state.manufacturingRequest.statusId == 4) {
      this.setState({
        nextStatusList: [
          { state: "Quality-Passed", value: "4" },
          { state: "Delivered-To-Warehouse", value: "5" },
          { state: "Cancel", value: "7" },
        ],
      });
    } else if (this.state.manufacturingRequest.statusId == 5) {
      this.setState({
        nextStatusList: [
          { state: "Delivered-To-Warehouse", value: "5" },
          { state: "Fg-Added-To-Inventory", value: "6" },
        ],
      });
    } else if (this.state.manufacturingRequest.statusId == 6) {
      this.setState({
        nextStatusList: [{ state: "Fg-Added-To-Inventory", value: "6" }],
      });
    } else if (this.state.manufacturingRequest.statusId == 7) {
      this.setState({
        nextStatusList: [{ state: "Cancelled", value: "7" }],
      });
    }
  };
  LoadProductName = () => {
    {
      var pd = [];
      this.context.prods.map((r) =>
        pd.push({
          value: r.id,
          label: r.name,
        })
      );
      this.setState({ productNames: pd });
    }
  };
  GetProductName = (id) => {
    var list = this.state.productNames.filter((f) => f.value == id);
    if (list.length > 0) return list[0].label;
    return "";
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateManufacturingRequestOrder = () => {
    const {
      manufacturingRequest,
      manufacturingTasks,
      manufacturingRawMaterials,
    } = this.state;

    // 🚨 If moving to Making-Complete, validate dependencies
    if (parseInt(manufacturingRequest.statusId) === 3) {
      // 1. Tasks check
      const incompleteTasks = manufacturingTasks.filter(
        (t) => t.statusId !== 3
      );
      if (incompleteTasks.length > 0) {
        this.ShowMessagBox(
          "Validation Error",
          "All Manufacturing Tasks must be completed before marking as Making-Complete."
        );
        return;
      }

      // 2. Raw Materials check
      const pendingRawMaterials = manufacturingRawMaterials.filter(
        (rm) => rm.statusId === 1
      );
      if (pendingRawMaterials.length > 0) {
        this.ShowMessagBox(
          "Validation Error",
          "All Raw Materials must be delivered (not in Requested state) before marking as Making-Complete."
        );
        return;
      }
    }

    this.ShowLoadSpinner();

    var tmp = this.state.manufacturingRequest;
    tmp.salesOrderId = this.state.selectedSalesOrderId;
    tmp.productManufacturingTasks = this.state.manufacturingTasks;
    tmp.productManufacturingRawMaterials = this.state.manufacturingRawMaterials;
    tmp.productionFinishedGoodItems = this.state.productionFinishedGoodItems;

    if (this.props.Type == "Add") {
      tmp.storeId = this.context.storeId;
      tmp.statusWofklowDescription =
        "<p>" +
        this.context.GetInDateFormat(new Date()) +
        "=> " +
        "NewOrder" +
        "</p>";
    } else {
      if (
        this.state.previousStatusId != this.state.manufacturingRequest.statusId
      ) {
        tmp.statusWofklowDescription +=
          "<p>" +
          this.context.GetInDateFormat(new Date()) +
          "=> " +
          this.context.manufacturingStatusTypes.filter(
            (d) => d.id == this.state.manufacturingRequest.statusId
          )[0].name +
          "</p>";
      }
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmp),
    };

    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/AddOrUpdateManufacturingRequestOrder/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.context.GetAllProducts?.();
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        } else {
          alert("Error Code: " + res.status);
          this.HideLoadSpinner();
          return;
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateManufacturingRequestOrder();
  };
  GetWarehouseName = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "productName":
        this.state.manufacturingRequest.productName = value;
        break;
      case "warehouseId":
        this.state.manufacturingRequest.warehouseId = value;
        // 🔄 also re-stamp any existing finished goods with the new WH
        this.setState({
          manufacturingRequest: this.state.manufacturingRequest,
          productionFinishedGoodItems:
            this.state.productionFinishedGoodItems.map((it) => ({
              ...it,
              warehouseId: value,
            })),
        });
        return; // we've already set state; exit early
      case "qty":
        this.state.manufacturingRequest.qty = value;
        break;
      case "customDetails":
        this.state.manufacturingRequest.customDetails = value;
        break;
      case "statusId":
        this.state.manufacturingRequest.statusId = value;
        break;
      case "statusWofklowDescription":
        this.state.manufacturingRequest.statusWofklowDescription = value;
        break;
      case "createdBy":
        this.state.manufacturingRequest.createdBy = value;
        break;
      case "assignedTo":
        this.state.manufacturingRequest.assignedTo = value;
        break;
    }

    this.setState({ manufacturingRequest: this.state.manufacturingRequest });
  };

  OnProductNameChange = (e) => {
    this.state.manufacturingRequest.productId = e.value;
    this.setState({ manufacturingRequest: this.state.manufacturingRequest });
  };

  UpdateManufacturingTask = (item, index) => {
    this.state.manufacturingTasks[index].taskName = item.taskName;
    this.state.manufacturingTasks[index].taskDescription = item.taskDescription;
    this.state.manufacturingTasks[index].assignedTo = item.assignedTo;
    this.state.manufacturingTasks[index].statusId = Number(item.statusId);
    this.state.manufacturingTasks[index].seqNo = item.seqNo;

    this.setState(
      {
        manufacturingTasks: this.state.manufacturingTasks,
      },
      () => {
        this.setState({ editManufacturingTaskModalShow: false }, () => {});
      }
    );
  };

  AddManufacturingTask = (item) => {
    this.setState(
      {
        manufacturingTasks: [
          ...this.state.manufacturingTasks,
          {
            taskName: item.taskName,
            taskDescription: item.taskDescription,
            assignedTo: item.assignedTo,
            statusId: Number(item.statusId),
            seqNo: this.state.manufacturingTasks.length + 1,
          },
        ],
      },
      () => {
        this.onHideManufacturingTaskModal();
      }
    );
  };
  onHideManufacturingTaskModal = () => {
    this.setState({ showManufacturingTaskModal: false });
  };

  handleManufacturingTaskAddItems = (e) => {
    this.setState({ showManufacturingTaskModal: true });
  };

  onHideManufacturingTaskEditModal = () => {
    this.setState({ editManufacturingTaskModalShow: false });
  };
  OnManufacturingTaskEditButtonClick = (e, i) => {
    this.setState({ editManufacturingTaskRow: i }, () => {
      this.setState({ editManufacturingTaskModalShow: true }, () => {});
    });
  };
  handleManufacturingTaskRemoveClick = (indexno) => {
    const list = [...this.state.manufacturingTasks];
    list.splice(indexno, 1);
    this.setState({ manufacturingTasks: list }, () => {});
  };

  UpdateManufacturingRawMaterial = (item, index) => {
    this.state.manufacturingRawMaterials[index].rawMaterialId =
      item.rawMaterialId;
    this.state.manufacturingRawMaterials[index].rawMaterialName =
      item.rawMaterialName;
    this.state.manufacturingRawMaterials[index].unit = item.unit;
    this.state.manufacturingRawMaterials[index].price = item.price;
    this.state.manufacturingRawMaterials[index].qty = item.qty;
    this.state.manufacturingRawMaterials[index].details = item.details;
    this.state.manufacturingRawMaterials[index].statusId = Number(
      item.statusId
    );

    this.setState(
      {
        manufacturingRawMaterials: this.state.manufacturingRawMaterials,
      },
      () => {
        this.setState(
          { editManufacturingRawMaterialModalShow: false },
          () => {}
        );
      }
    );
  };

  AddManufacturingRawMaterial = (item) => {
    this.setState(
      {
        manufacturingRawMaterials: [
          ...this.state.manufacturingRawMaterials,
          {
            rawMaterialId: item.rawMaterialId,
            rawMaterialName: item.rawMaterialName,
            unit: item.unit,
            price: item.price,
            qty: item.qty,
            details: item.details,
            statusId: Number(item.statusId),
          },
        ],
      },
      () => {
        this.onHideManufacturingRawMaterialModal();
      }
    );
  };
  onHideManufacturingRawMaterialModal = () => {
    this.setState({ showManufacturingRawMaterialModal: false });
  };

  handleManufacturingRawMaterialAddItems = (e) => {
    this.setState({ showManufacturingRawMaterialModal: true });
  };
  handleProductlAddItems = (e) => {
    this.setState({ showProductInWardModal: true });
  };

  onHideManufacturingRawMaterialEditModal = () => {
    this.setState({ editManufacturingRawMaterialModalShow: false });
  };
  OnManufacturingRawMaterialEditButtonClick = (e, i) => {
    this.setState({ editManufacturingRawMaterialRow: i }, () => {
      this.setState({ editManufacturingRawMaterialModalShow: true }, () => {});
    });
  };
  handleManufacturingRawMaterialRemoveClick = (indexno) => {
    const list = [...this.state.manufacturingRawMaterials];
    list.splice(indexno, 1);
    this.setState({ manufacturingRawMaterials: list }, () => {});
  };
  GetRawMaterialName = (id) => {
    var list = this.props.rawMaterialsInventory.filter((f) => f.id == id);
    if (list.length > 0) return list[0].name;
    return "";
  };
  componentDidMount() {
    if (this.state.firstload == false) {
      this.state.firstload = true;
      if (this.state.productNames.length == 0) this.LoadProductName();
      this.GetSalesOrders();
      if (this.props.Type == "Edit") {
        this.setState(
          {
            manufacturingRequest: JSON.parse(
              JSON.stringify(this.props.manufacturingRequest)
            ),
          },
          () => {
            this.LoadNextStatus();
          }
        );
        this.setState(
          {
            manufacturingTasks:
              this.props.manufacturingRequest.productManufacturingTasks.sort(
                (a, b) => (a.seqNo > b.seqNo ? 1 : -1)
              ),
          },
          () => {}
        );
        this.setState({
          manufacturingRawMaterials:
            this.props.manufacturingRequest.productManufacturingRawMaterials,
        });
        this.setState({
          productionFinishedGoodItems:
            this.props.manufacturingRequest.productionFinishedGoodItems || [],
        });
      } else {
        this.state.manufacturingRequest.createdBy = this.context.userData.id;
        this.setState({
          manufacturingRequest: this.state.manufacturingRequest,
        });
      }
    }
    var d1 = document.getElementById("one");
    d1.innerHTML =
      this.props.manufacturingRequest != undefined
        ? this.props.manufacturingRequest.statusWofklowDescription
        : "";
  }
  GetUserNameById = (id) => {
    var result = this.props.users.filter((f) => f.id == id);
    if (result.length > 0) return result[0].emailId;
    else return "";
  };
  GetRawMaterialsTotalCost = () => {
    let sum = 0;
    this.state.manufacturingRawMaterials.forEach((v) => {
      sum += v.price * v.qty;
    });
    return sum;
  };
  OnChangeSeqNoOfTasks = (e, i) => {
    const { name, value } = e.target;
    this.state.manufacturingTasks[i].seqNo = value;
    this.setState({ manufacturingTasks: this.state.manufacturingTasks });
  };

  GetWarehouseName = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  GetProductionRequestHTML = () => {
    var str = "<html>";
    str += '<div style="width: 100%;text-align: center">';
    str += "<h2><u>Work Order Sheet</u></h2>";
    str +=
      this.context.store.name +
      " - " +
      this.GetWarehouseName(this.state.manufacturingRequest.warehouseId);

    str +=
      "<br/><table style='width: 100%; padding: 6px 2px 2px 2px; border-collapse: collapse; font-size: 14px; text-align: left; table-layout: auto;'><tbody>";
    str +=
      "<tr><td style='padding:6px; vertical-align:top; width:150px;'><strong>Production NO:</strong></td><td style='padding:6px;'>" +
      (this.state.manufacturingRequest.pmrNo || "") +
      "</td></tr>";
    str +=
      "<tr><td style='padding:6px; vertical-align:top;'><strong>Date:</strong></td><td style='padding:6px;'>" +
      this.context.GetInDateFormat(
        new Date(this.state.manufacturingRequest.created || new Date())
      ) +
      "</td></tr>";

    str +=
      "<tr><td style='padding:6px; vertical-align:top;'><strong>Created By:</strong></td><td style='padding:6px;'>" +
      (this.context.userData?.emailId ||
        this.state.manufacturingRequest.createdBy ||
        "") +
      "</td></tr>";
    str +=
      "<tr><td style='padding:6px; vertical-align:top;'><strong>Assigned To:</strong></td><td style='padding:6px;'>" +
      (this.GetUserNameById(this.state.manufacturingRequest.assignedTo) ||
        this.state.manufacturingRequest.assignedTo ||
        "") +
      "</td></tr>";
    str +=
      "<tr><td style='padding:6px; vertical-align:top;'><strong>Product Job / Title:</strong></td><td style='padding:6px;'>" +
      (this.state.manufacturingRequest.productName || "") +
      "</td></tr>";
    str +=
      "<tr><td style='padding:6px; vertical-align:top;'><strong>Quantity Required:</strong></td><td style='padding:6px;'>" +
      (this.state.manufacturingRequest.qty || "") +
      "</td></tr>";

    str +=
      "<tr><td style='padding:6px; vertical-align:top;'><strong>Requirements in Detail:</strong></td><td style='padding:6px; white-space:pre-wrap;'>" +
      (this.state.manufacturingRequest.customDetails || "") +
      "</td></tr>";
    str += "</tbody></table>";

    // --- Tasks & Assignment ---
    const tasks = Array.isArray(this.state.manufacturingTasks)
      ? this.state.manufacturingTasks
      : [];
    str += "<br/><h3 style='text-align:left;'>Tasks & Assignment</h3>";
    if (tasks.length === 0) {
      str +=
        "<div style='text-align:left; font-style:italic;'>No tasks added.</div>";
    } else {
      str +=
        "<table style='width:100%; border-collapse: collapse; font-size:13px;'><thead>" +
        "<tr>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>#</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Task Name</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Description</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Assigned To</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Seq No</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Status</th>" +
        "</tr></thead><tbody>";

      tasks.forEach((t, idx) => {
        const statusText =
          t.statusId == 1
            ? "Open"
            : t.statusId == 2
            ? "In Progress"
            : t.statusId == 3
            ? "Complete"
            : "";
        const assignedName =
          this.GetUserNameById(t.assignedTo) || t.assignedTo || "";
        str +=
          "<tr>" +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            idx + 1
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${
            t.taskName || ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${
            t.taskDescription || ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${assignedName}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            t.seqNo || ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${statusText}</td>` +
          "</tr>";
      });

      str += "</tbody></table>";
    }

    // --- Raw Material Requirements ---
    const rms = Array.isArray(this.state.manufacturingRawMaterials)
      ? this.state.manufacturingRawMaterials
      : [];
    str += "<br/><h3 style='text-align:left;'>Raw Material Requirements</h3>";
    if (rms.length === 0) {
      str +=
        "<div style='text-align:left; font-style:italic;'>No raw materials added.</div>";
    } else {
      str +=
        "<table style='width:100%; border-collapse: collapse; font-size:13px;'><thead>" +
        "<tr>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>#</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Raw Material</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Details</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:right;'>Price</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Qty</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Unit</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:right;'>SubTotal</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Status</th>" +
        "</tr></thead><tbody>";

      rms.forEach((r, idx) => {
        const subtotal = (r.price || 0) * (r.qty || 0);
        const statusText =
          r.statusId == 1
            ? "Requested"
            : r.statusId == 2
            ? "Delivered"
            : r.statusId == 3
            ? "Out Of Stock"
            : r.statusId == 4
            ? "Returned"
            : "";
        str +=
          "<tr>" +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            idx + 1
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${
            r.rawMaterialName || this.GetRawMaterialName(r.rawMaterialId) || ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${
            r.details || ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:right;'>${
            r.price != null ? r.price : ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            r.qty != null ? r.qty : ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            r.unit || ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:right;'>${subtotal}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${statusText}</td>` +
          "</tr>";
      });

      // total row
      const total = this.GetRawMaterialsTotalCost();
      str +=
        "<tr>" +
        "<td colspan='6' style='border:1px solid #ddd;padding:6px;text-align:right;'><strong>Total</strong></td>" +
        `<td style='border:1px solid #ddd;padding:6px;text-align:right;'><strong>${total}</strong></td>` +
        "<td style='border:1px solid #ddd;padding:6px;text-align:center;'></td>" +
        "</tr>";

      str += "</tbody></table>";
    }

    // --- Finished Goods (new) ---
    const fgs = Array.isArray(this.state.productionFinishedGoodItems)
      ? this.state.productionFinishedGoodItems
      : [];
    str += "<br/><h3 style='text-align:left;'>Finished Goods</h3>";
    if (fgs.length === 0) {
      str +=
        "<div style='text-align:left; font-style:italic;'>No finished goods added.</div>";
    } else {
      str +=
        "<table style='width:100%; border-collapse: collapse; font-size:13px;'><thead>" +
        "<tr>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>#</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Product</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Details</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Qty</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Unit</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:left;'>Warehouse</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Seq No</th>" +
        "<th style='border:1px solid #ddd;padding:6px;background:#f2f2f2;text-align:center;'>Status</th>" +
        "</tr></thead><tbody>";

      let totalFinishedQty = 0;
      fgs.forEach((f, idx) => {
        const prodLabel =
          f.productName ||
          this.GetProductName(f.productId) ||
          this.GetProductInfo(f) ||
          "";
        const details = f.details || f.remarks || "";
        const qty = Number(f.qty || 0);
        totalFinishedQty += qty;
        const unit = f.unit || f.uom || "";
        const wh = this.GetWarehouseName(f.warehouseId) || "";
        const seq = f.seqNo || "";
        const statusText = f.addedToStock
          ? "Added to Stock"
          : f.statusId
          ? f.statusId === 1
            ? "Pending"
            : f.statusId === 2
            ? "Added"
            : ""
          : "";

        str +=
          "<tr>" +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            idx + 1
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${prodLabel}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${details}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${
            f.qty != null ? f.qty : ""
          }</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${unit}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:left;'>${wh}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${seq}</td>` +
          `<td style='border:1px solid #ddd;padding:6px;text-align:center;'>${statusText}</td>` +
          "</tr>";
      });

      // finished goods totals row
      str +=
        "<tr>" +
        "<td colspan='3' style='border:1px solid #ddd;padding:6px;text-align:right;'><strong>Total Finished Qty</strong></td>" +
        `<td style='border:1px solid #ddd;padding:6px;text-align:center;'><strong>${totalFinishedQty}</strong></td>` +
        "<td colspan='4' style='border:1px solid #ddd;padding:6px;text-align:center;'></td>" +
        "</tr>";

      str += "</tbody></table>";
    }

    str +=
      "<br/><div style='text-align:left; font-size:12px; color:#666;'>Generated on: " +
      this.context.GetInDateFormat(new Date()) +
      "</div>";

    str += "</div></html>";
    return str;
  };

  PrintMe = () => {
    var printWindow = window.open("", "_blank");
    printWindow.document.write(this.GetProductionRequestHTML());
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };
  onPrintFinished = (status, printWindow) => {
    var osvar = this.getOS();
    if (osvar == "Windows") printWindow.close();
  };
  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  render() {
    return (
      <div className="container ">
        // Replace the existing <Modal> ... </Modal> block in your class
        component's render() with the code below. // FUNCTIONALITY IS NOT
        CHANGED — all handlers and state/prop references (this.state,
        this.props, this.context, etc.) are preserved.
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="xl"
          backdrop="static"
          keyboard={false}
          dialogClassName="order-modal"
        >
          {/* Message box & spinner (unchanged behavior) */}
          {this.state.msgboxOpen ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : null}
          {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : null}

          <Form onSubmit={this.handleSubmit}>
            <Modal.Header
              closeButton
              className="bg-primary text-light border-0 rounded-top"
              style={{ alignItems: "center" }}
            >
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fw-bold"
              >
                {this.props.Type === "Edit"
                  ? "Edit Production Order"
                  : "Add Production Order"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body
              className="show-grid p-3 bg-white"
              style={{ fontSize: "0.95rem" }}
            >
              {/* modals for nested editors (unchanged) */}
              {this.state.showManufacturingTaskModal && (
                <ManufacturingTask
                  onHide={this.onHideManufacturingTaskModal}
                  AddManufacturingTask={this.AddManufacturingTask}
                  UpdateManufacturingTask={this.UpdateManufacturingTask}
                  users={this.props.users}
                  Type="Add"
                />
              )}

              {this.state.editManufacturingTaskModalShow && (
                <ManufacturingTask
                  onHide={this.onHideManufacturingTaskEditModal}
                  AddManufacturingTask={this.AddManufacturingTask}
                  UpdateManufacturingTask={this.UpdateManufacturingTask}
                  Type="Edit"
                  users={this.props.users}
                  manufacturingTask={
                    this.state.manufacturingTasks[
                      this.state.editManufacturingTaskRow
                    ]
                  }
                  Index={this.state.editManufacturingTaskRow}
                />
              )}

              {this.state.showManufacturingRawMaterialModal && (
                <ManufacturingRawMaterials
                  onHide={this.onHideManufacturingRawMaterialModal}
                  AddManufacturingRawMaterial={this.AddManufacturingRawMaterial}
                  Type="Add"
                  rawMaterialsInventory={this.props.rawMaterialsInventory}
                  manufacturingRequest={this.state.manufacturingRequest}
                />
              )}

              {this.state.editManufacturingRawMaterialModalShow && (
                <ManufacturingRawMaterials
                  onHide={this.onHideManufacturingRawMaterialEditModal}
                  UpdateManufacturingRawMaterial={
                    this.UpdateManufacturingRawMaterial
                  }
                  Type="Edit"
                  manufacturingRawMaterial={
                    this.state.manufacturingRawMaterials[
                      this.state.editManufacturingRawMaterialRow
                    ]
                  }
                  Index={this.state.editManufacturingRawMaterialRow}
                  rawMaterialsInventory={this.props.rawMaterialsInventory}
                  manufacturingRequest={this.state.manufacturingRequest}
                />
              )}

              <Row className="mb-3">
                <Col md={8}>
                  <FloatingLabel
                    label="Link Sales Order (optional)"
                    className="mb-2"
                  >
                    <Form.Select
                      size="lg"
                      value={this.state.selectedSalesOrderId || ""}
                      onChange={(e) =>
                        this.setState({ selectedSalesOrderId: e.target.value })
                      }
                      disabled={!!this.state.salesOrderLoaded} // <- disable when locked
                    >
                      <option value="">-- None --</option>
                      {this.state.salesOrders.map((so) => (
                        <option key={so.Id || so.id} value={so.Id || so.id}>
                          {`${so.OrderId || so.orderId || so.OrderNo || ""} ${
                            so.CustomerName ? " — " + so.CustomerName : ""
                          }`}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col
                  md={4}
                  className="d-flex align-items-center justify-content-center"
                >
                  {/* IMPORTANT: type="button" prevents the form from submitting */}
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="lg"
                    disabled={
                      !this.state.selectedSalesOrderId ||
                      this.state.salesOrderLoaded
                    } // <- also disable if locked
                    onClick={() =>
                      this.LoadSalesOrderItems(this.state.selectedSalesOrderId)
                    }
                    title="Load sales order items into Finished Goods"
                    className="w-100"
                  >
                    Load Items from Sales Order
                  </Button>
                </Col>
              </Row>

              {/* Top section: two columns with card-like appearance */}
              <div className="mb-3 p-3 shadow-sm rounded-3 bg-light">
                <Row className="gx-3">
                  <Col md={7}>
                    <Row>
                      <Col md={8}>
                        <FloatingLabel
                          label="Production(PMR) No"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            size="lg"
                            name="pmrNo"
                            required
                            readOnly
                            value={this.state.manufacturingRequest.pmrNo}
                            autoComplete="off"
                            className="form-control-lg"
                          />
                        </FloatingLabel>
                      </Col>

                      <Col
                        md={4}
                        className="d-flex align-items-center justify-content-center p-0"
                      >
                        <Button
                          variant="warning"
                          size="lg"
                          disabled={!this.state.manufacturingRequest.pmrNo}
                          onClick={() => this.PrintMe()}
                          className="text-nowrap w-100"
                        >
                          <div style={{ lineHeight: 1 }}>
                            <div>
                              <FaRegFilePdf size={20} /> &nbsp; PDF / Print
                              &nbsp; <BsFillPrinterFill size={20} />
                            </div>
                          </div>
                        </Button>
                      </Col>
                    </Row>

                    <FloatingLabel
                      label="Production Plant / Warehouse Name *"
                      className="mb-3"
                    >
                      <Form.Select
                        name="warehouseId"
                        size="lg"
                        value={
                          this.state.manufacturingRequest.warehouseId || ""
                        }
                        required
                        disabled={
                          this.state.manufacturingRawMaterials.length > 0
                        }
                        onChange={(e) => this.handleInputChange(e)}
                        className="text-start"
                      >
                        <option value={""}></option>
                        {this.props.rawmaterialwarehouse.map((m) => (
                          <option key={m.id} value={m.id}>
                            {m.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>

                    <FloatingLabel label="Work Order Name *" className="mb-3">
                      <Form.Control
                        type="text"
                        size="lg"
                        name="productName"
                        required
                        maxLength={254}
                        value={this.state.manufacturingRequest.productName}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </FloatingLabel>

                    {/* <FloatingLabel label="Qty required *" className="mb-3">
                      <Form.Control
                        type="number"
                        size="lg"
                        name="qty"
                        required
                        value={this.state.manufacturingRequest.qty}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </FloatingLabel> */}

                    <FloatingLabel label="Created By *" className="mb-3">
                      <Form.Control
                        type="text"
                        size="lg"
                        name="createdBy"
                        disabled
                        value={this.context.userData.emailId}
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </FloatingLabel>

                    <FloatingLabel label="Assigned To *" className="mb-3">
                      <Form.Select
                        name="assignedTo"
                        size="lg"
                        value={this.state.manufacturingRequest.assignedTo || ""}
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {this.props.users.map((d) =>
                          d.emailId === "productsupport" ? null : (
                            <option key={d.id} value={d.id}>
                              {d.emailId}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </FloatingLabel>

                    <FloatingLabel label="Status *" className="mb-3">
                      <Form.Select
                        name="statusId"
                        size="lg"
                        value={this.state.manufacturingRequest.statusId}
                        required
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        {this.state.nextStatusList.map((d) => (
                          <option
                            key={d.value}
                            value={d.value}
                          >{`${d.value}. ${d.state}`}</option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col md={5}>
                    <div className="h-100 d-flex flex-column">
                      <Form.Group as={Row} className="mb-2 flex-grow-1">
                        <Col sm="12">
                          <label className="form-label fw-semibold">
                            Production Requirements details (if any)
                          </label>
                          <Form.Control
                            as="textarea"
                            rows={12}
                            maxLength={2499}
                            name="customDetails"
                            value={
                              this.state.manufacturingRequest.customDetails
                            }
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </Col>
                      </Form.Group>

                      <div className="mt-auto border rounded p-2 bg-white">
                        <h6 className="text-center mb-0">Status Workflow</h6>
                        <div id="one" className="text-start mt-2" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Tasks header */}
              <Row className="align-items-center mb-2">
                <Col md={8}>
                  <h5 className="mb-0">Work Order Items/Tasks & Assignment</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button
                    id="addbutton"
                    onClick={(e) => this.handleManufacturingTaskAddItems(e)}
                    variant="primary"
                  >
                    + Add
                  </Button>
                </Col>
              </Row>

              {/* Tasks table - improved visual */}
              <div className="table-responsive shadow-sm rounded">
                <Table hover bordered size="sm" className="mb-0 align-middle">
                  <thead className="bg-secondary text-white">
                    <tr>
                      <th style={{ width: "3%" }}>#</th>
                      <th style={{ width: "20%" }}>Name</th>
                      <th style={{ width: "40%" }}>Description</th>
                      <th style={{ width: "10%" }}>Assigned To</th>
                      <th style={{ width: "10%" }}>Seq No</th>
                      <th style={{ width: "10%" }}>Status</th>
                      <th style={{ width: "7%" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(this.state.manufacturingTasks) &&
                      this.state.manufacturingTasks.map((row, i) => (
                        <tr key={`task-${i}`} className="text-center">
                          <td className="text-center">{i + 1}</td>
                          <td className="text-start">{row.taskName}</td>
                          <td className="text-start">{row.taskDescription}</td>
                          <td>{this.GetUserNameById(row.assignedTo)}</td>
                          <td>
                            <Form.Control
                              type="text"
                              size="sm"
                              name="seqNo"
                              value={row.seqNo}
                              onChange={(e) => this.OnChangeSeqNoOfTasks(e, i)}
                              className="text-center"
                            />
                          </td>
                          <td>
                            {row.statusId == 1 ? (
                              <span className="badge bg-secondary">Open</span>
                            ) : row.statusId == 2 ? (
                              <span className="badge bg-info">In Progress</span>
                            ) : row.statusId == 3 ? (
                              <span className="badge bg-success">Complete</span>
                            ) : null}
                          </td>
                          <td className="text-center">
                            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
                              <Button
                                className="rounded-circle me-1"
                                variant="warning"
                                size="sm"
                                onClick={(e) =>
                                  this.OnManufacturingTaskEditButtonClick(e, i)
                                }
                              >
                                <BsFillPencilFill size={14} />
                              </Button>
                            </OverlayTrigger>
                            <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>}>
                              <Button
                                className="rounded-circle"
                                variant="danger"
                                size="sm"
                                onClick={(e) =>
                                  this.handleManufacturingTaskRemoveClick(i)
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  className="bi bi-trash"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                  <path
                                    fillRule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                  />
                                </svg>
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>

              <br />

              {/* Raw Materials header */}
              <Row className="align-items-center mb-2">
                <Col md={8}>
                  <h5 className="mb-0">Raw Material Requirements</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button
                    id="addbutton-raw"
                    onClick={(e) =>
                      this.handleManufacturingRawMaterialAddItems(e)
                    }
                    variant="primary"
                  >
                    + Add
                  </Button>
                </Col>
              </Row>

              {/* Raw Materials table */}
              <div className="table-responsive shadow-sm rounded">
                <Table hover bordered size="sm" className="mb-0 align-middle">
                  {window.innerWidth > 900 ? (
                    <>
                      <thead className="bg-secondary text-white">
                        <tr className="text-center">
                          <th style={{ width: "3%" }}>#</th>
                          <th style={{ width: "20%" }} className="text-start">
                            RM Name
                          </th>
                          <th style={{ width: "30%" }} className="text-start">
                            Details
                          </th>
                          <th style={{ width: "10%" }}>Pur.Rate</th>
                          <th style={{ width: "5%" }}>Qty/Wt</th>
                          <th style={{ width: "5%" }}>Unit</th>
                          <th style={{ width: "10%" }}>
                            SubTotal / Estimation{" "}
                            <div style={{ fontSize: "0.9rem" }}>
                              Rs. {this.GetRawMaterialsTotalCost()}
                            </div>
                          </th>
                          <th style={{ width: "10%" }}>Status</th>
                          <th style={{ width: "7%" }}>Options</th>
                        </tr>
                      </thead>
                    </>
                  ) : (
                    <>
                      <thead className="bg-secondary text-white">
                        <tr className="text-center">
                          <th style={{ width: "3%" }}>#</th>
                          <th style={{ width: "20%" }} className="text-start">
                            RM Name
                          </th>

                          <th style={{ width: "10%" }}>Pur.Rate</th>
                          <th style={{ width: "5%" }}>Qty/Wt</th>
                          <th style={{ width: "5%" }}>Unit</th>
                          <th style={{ width: "10%" }}>
                            ST{" "}
                            <div style={{ fontSize: "0.9rem" }}>
                              Rs. {this.GetRawMaterialsTotalCost()}
                            </div>
                          </th>
                          <th style={{ width: "10%" }}>Status</th>
                          <th style={{ width: "7%" }}>Options</th>
                        </tr>
                      </thead>
                    </>
                  )}

                  <tbody>
                    {Array.isArray(this.state.manufacturingRawMaterials) &&
                      this.state.manufacturingRawMaterials.map((row, i) => (
                        <tr key={`rm-${i}`} className="text-center">
                          <td>{i + 1}</td>
                          <td className="text-start">{row.rawMaterialName}</td>
                          <td className="text-start">{row.details}</td>
                          <td>{row.price}</td>
                          <td>{row.qty}</td>
                          <td>{row.unit}</td>
                          <td>
                            <b>{row.price * row.qty}</b>
                          </td>
                          <td>
                            {row.statusId === 1 ? (
                              <span className="badge bg-secondary">
                                Requested
                              </span>
                            ) : row.statusId === 2 ? (
                              <span className="badge bg-success">
                                Delivered
                              </span>
                            ) : row.statusId === 3 ? (
                              <span className="badge bg-danger">
                                Out Of Stock
                              </span>
                            ) : row.statusId === 4 ? (
                              <span className="badge bg-warning">Returned</span>
                            ) : null}
                          </td>
                          <td className="text-center">
                            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
                              <Button
                                className="rounded-circle me-1"
                                variant="warning"
                                size="sm"
                                disabled={row.statusId >= 1}
                                onClick={(e) =>
                                  this.OnManufacturingRawMaterialEditButtonClick(
                                    e,
                                    i
                                  )
                                }
                              >
                                <BsFillPencilFill size={14} />
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>}>
                              <Button
                                className="rounded-circle"
                                variant="danger"
                                size="sm"
                                disabled={row.statusId > 1}
                                onClick={(e) =>
                                  this.handleManufacturingRawMaterialRemoveClick(
                                    i
                                  )
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  className="bi bi-trash"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                  <path
                                    fillRule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                  />
                                </svg>
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>

              <br />

              {/* Finished Goods area - unchanged but visually isolated */}
              {this.props.status &&
                (this.props.status == 5 || this.props.status == 6) && (
                  <div className="p-2 border rounded shadow-sm bg-white">
                    <FinishedGoodsTable
                      key={
                        this.state.manufacturingRequest.warehouseId || "no-wh"
                      }
                      items={this.state.productionFinishedGoodItems}
                      warehouses={this.props.rawmaterialwarehouse}
                      prods={this.context.prods}
                      defaultWarehouseId={
                        this.state.manufacturingRequest.warehouseId
                      }
                      onAdd={(item) => {
                        const warehouseId =
                          this.state.manufacturingRequest.warehouseId;
                        this.setState({
                          productionFinishedGoodItems: [
                            ...this.state.productionFinishedGoodItems,
                            {
                              ...item,
                              warehouseId,
                              seqNo:
                                this.state.productionFinishedGoodItems.length +
                                1,
                            },
                          ],
                        });
                      }}
                      onUpdate={(item, index) => {
                        const warehouseId =
                          this.state.manufacturingRequest.warehouseId;
                        const list = [
                          ...this.state.productionFinishedGoodItems,
                        ];
                        list[index] = { ...list[index], ...item, warehouseId };
                        this.setState({ productionFinishedGoodItems: list });
                      }}
                      onRemove={(index) => {
                        const it =
                          this.state.productionFinishedGoodItems[index];
                        const remove = () => {
                          const list = [
                            ...this.state.productionFinishedGoodItems,
                          ];
                          list.splice(index, 1);
                          this.setState({ productionFinishedGoodItems: list });
                        };

                        if (it?.addedToStock) {
                          Swal.fire({
                            title: "Warning!",
                            confirmButtonColor: "#23B14D",
                            cancelButtonColor: "#dbdbdb",
                            text: "This item is already added to Inventory Stock. If you delete, you may have to manually correct the InStock on the Inventory. Continue?",
                            showCancelButton: true,
                            confirmButtonText: "Yes",
                            cancelButtonText: "No",
                          }).then((result) => result.isConfirmed && remove());
                        } else remove();
                      }}
                    />
                  </div>
                )}
            </Modal.Body>

            <Modal.Footer className="bg-light border-0">
              <Form.Group className="me-auto">
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        /* Notes: - This markup intentionally keeps all handlers (onClick,
        onChange, etc.) and state/prop references as-is so functionality does
        not change. - Visual improvements include: clearer spacing, consistent
        paddings, badges for statuses, responsive tables, shadows and rounded
        corners, and clearer action buttons. - If you want a darker/light theme,
        or prefer Tailwind utilities instead of Bootstrap classes, tell me and I
        can provide a themed variant. */
      </div>
    );
  }
}
// --- FinishedGoodsTable (class) ---
export class FinishedGoodsTable extends Component {
  static contextType = CartContext;
  state = { showModal: false, editIndex: -1, modalKey: 0 };

  openAdd = () => this.setState({ showModal: true, editIndex: -1 });
  openEdit = (i) => this.setState({ showModal: true, editIndex: i });
  close = () => this.setState({ showModal: false, editIndex: -1 });

  // child asks to remount (reload itself & options after new product save)
  bumpChildKey = () => this.setState((s) => ({ modalKey: s.modalKey + 1 }));

  subTotal = (r) => Number(r.rate || 0) * Number(r.qty || 0);
  taxAmt = (r) => (this.subTotal(r) * Number(r.tax || 0)) / 100;
  total = (r) =>
    Math.round(this.subTotal(r) + this.taxAmt(r) - Number(r.discount || 0));
  sum = (fn) => (this.props.items || []).reduce((a, r) => a + fn(r), 0);

  fmt = (n, max = 0) =>
    Number(n || 0).toLocaleString(
      this.context?.storeSettings?.defaultLocale || "en-IN",
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: max,
        style: "currency",
        currency: this.context?.storeSettings?.defaultCurrency || "INR",
      }
    );
  GetProductLable = (product) => {
    let result = product.itemName;
    if (product.batchId)
      result +=
        this.context.store.businessTypeId ==
        this.context.BusinessTypes.STEELTRADERS
          ? ` CoilId:${product.batchId}`
          : ` BatchId:${product.batchId}`;

    if (product.remarks)
      result +=
        this.context.store.businessTypeId ==
        this.context.BusinessTypes.STEELTRADERS
          ? ` ${product.remarks}`
          : ` ${product.remarks}`;

    return result;
  };

  render() {
    const { items = [], warehouses = [] } = this.props;
    const editItem =
      this.state.editIndex >= 0 ? items[this.state.editIndex] : null;

    const showSteelExtras =
      this.context.store.businessTypeId ===
      this.context.BusinessTypes.STEELTRADERS;

    const whName = (id) => warehouses.find((w) => w.id === id)?.name || "";

    return (
      <div className="my-3 bg-light rounded-3">
        <Row>
          <Col md={8} className="text-start text-dark my-2">
            <h4>
              {" "}
              Finished Goods (Production output to go Product Inventory){" "}
            </h4>
          </Col>
          <Col md={4} className="text-end my-2">
            <Button
              variant="primary"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                this.openAdd();
              }}
            >
              + Add
            </Button>
          </Col>
        </Row>

        <Table
          bordered
          striped
          className="text-start"
          style={{ fontSize: "12px" }}
        >
          <thead className="bg-secondary text-white">
            <tr className="text-center">
              <td width="1%"></td>
              <td width="40%" className="text-start">
                Product Name
              </td>
              {/* <td width="15%" className="text-start">
                Remarks
              </td> */}
              {showSteelExtras ? <td width="6%">Pieces</td> : null}
              <td width="6%">Qty/Wt in Unit</td>
              {!showSteelExtras ? <td width="6%">Selling Rate/Unit</td> : null}
              <td width="6%">Unit</td>
              <td width="8%">WH</td>
              <td width="8%">InStock</td>
              <td width="8%" className="text-center">
                Options
              </td>
            </tr>
          </thead>
          <tbody>
            {items.map((r, i) => (
              <tr
                key={i}
                className="align-middle text-center"
                onClick={() => this.openEdit(i)}
              >
                <td>{i + 1}</td>
                <td className="text-start">
                  <b className="text-black fs-6">
                    {this.GetProductLable(r)}
                    {/* {r.itemName}
                    {r.batchId
                      ? showSteelExtras
                        ? ` CoilId:${r.batchId}`
                        : ` BatchId:${r.batchId}`
                      : ""} */}
                  </b>
                </td>
                {/* <td className="text-start">{r.remarks}</td> */}
                {showSteelExtras ? <td>{r.pieces}</td> : null}
                <td>{r.qty}</td>
                {!showSteelExtras ? (
                  <td className="text-end">{this.fmt(r.mrp)}</td>
                ) : null}
                <td>{r.unit}</td>
                <td>{whName(r.warehouseId)}</td>
                <td>
                  {r.addedToStock ? (
                    <span className="bg-success text-white p-1 rounded">
                      Added
                    </span>
                  ) : (
                    <span className="bg-warning text-dark p-1 rounded">
                      Not Added
                    </span>
                  )}
                </td>
                <td className="text-center">
                  <Button
                    size="sm"
                    className="rounded-circle"
                    variant="warning"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.openEdit(i);
                    }}
                  >
                    <BsFillPencilFill size="16" />
                  </Button>{" "}
                  <Button
                    size="sm"
                    variant="rounded-circle"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.onRemove(i);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                      <path
                        fillRule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                      />
                    </svg>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {this.state.showModal && (
          <AddOrEditFinishedGoodItem
            key={`${this.state.editIndex}-${
              this.props.defaultWarehouseId || ""
            }-${this.state.modalKey}`}
            show={this.state.showModal}
            onHide={this.close}
            Type={this.state.editIndex >= 0 ? "Edit" : "Add"}
            item={editItem}
            prods={this.props.prods || this.context.prods || []}
            defaultWarehouseId={this.props.defaultWarehouseId}
            warehouses={this.props.warehouses || []}
            onReloadMe={this.bumpChildKey}
            onSave={(payload) => {
              payload.warehouseId =
                payload.warehouseId || this.props.defaultWarehouseId;
              if (this.state.editIndex >= 0) {
                this.props.onUpdate(payload, this.state.editIndex);
              } else {
                this.props.onAdd(payload);
              }
              this.close();
            }}
          />
        )}
      </div>
    );
  }
}

class AddOrEditFinishedGoodItem extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    const r = props.item || {};
    this.state = {
      productOptions: [],
      addProductModal: false,

      itemId: r.itemId || "",
      itemName: r.itemName || "",
      remarks: r.remarks || "",
      pieces: r.pieces ?? 1,
      weight: r.weight ?? 1,
      qty: r.qty ?? 1,
      localWt: r.localWt ?? "",
      rate: r.rate ?? 0,
      tax: r.tax ?? 0,
      unit: r.unit || "",
      mrp: r.mrp ?? 0,
      sku: r.sku || "",
      hsnCode: r.hsnCode || "",
      batchId: r.batchId || "",
      warehouseId: r.warehouseId || props.defaultWarehouseId || "",
    };
  }

  componentDidMount() {
    this.loadProductOptions();
  }

  componentDidUpdate(prevProps) {
    // sync warehouse changes and prods updates
    if (
      prevProps.defaultWarehouseId !== this.props.defaultWarehouseId ||
      prevProps.prods !== this.props.prods ||
      (prevProps.prods?.length || 0) !== (this.props.prods?.length || 0)
    ) {
      if (prevProps.defaultWarehouseId !== this.props.defaultWarehouseId) {
        this.setState((s) => ({
          warehouseId: this.props.defaultWarehouseId || s.warehouseId || "",
        }));
      }
      this.loadProductOptions();
    }
  }

  loadProductOptions = () => {
    const { prods = [], defaultWarehouseId } = this.props;
    const filtered = defaultWarehouseId
      ? prods.filter((p) => p.warehouseId === defaultWarehouseId)
      : prods;

    const options = filtered
      .map((p) => ({
        value: p.id,
        label:
          p.name +
          (p.batchId
            ? this.context.store.businessTypeId ===
              this.context.BusinessTypes.STEELTRADERS
              ? ` CoilId:${p.batchId}`
              : ` BatchId:${p.batchId}`
            : ""),
        raw: p,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    this.setState({ productOptions: options });
  };

  onProductChange = (opt) => {
    if (!opt) return;
    const p = opt.raw;
    this.setState({
      itemId: p.id,
      itemName: p.name,
      unit: p.unit || this.state.unit,
      hsnCode: p.hsnCode || "",
      batchId: p.batchId || "",
      sku: p.internalId || "",
      warehouseId:
        this.props.defaultWarehouseId ||
        p.warehouseId ||
        this.state.warehouseId,
    });
  };

  fmt = (n) =>
    Number(n || 0).toLocaleString(
      this.context?.storeSettings?.defaultLocale || "en-IN",
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: this.context?.storeSettings?.defaultCurrency || "INR",
      }
    );

  subTotal = () => Number(this.state.rate || 0) * Number(this.state.qty || 0);
  taxAmt = () => (this.subTotal() * Number(this.state.tax || 0)) / 100;
  total = () => Math.round(this.subTotal() + this.taxAmt());

  stopBubble = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
  };

  save = (e) => {
    this.stopBubble(e);
    if (!this.state.itemId || !this.state.itemName) return;

    const payload = {
      ...this.state,
      warehouseId: this.props.defaultWarehouseId || this.state.warehouseId,
    };
    this.props.onSave(payload);
  };

  render() {
    const showSteelExtras =
      this.context.store.businessTypeId ===
      this.context.BusinessTypes.STEELTRADERS;
    const unitLabel = this.state.unit || (showSteelExtras ? "ton" : "unit");

    return (
      <Modal
        {...this.props}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        onKeyDown={(e) => {
          if (e.key === "Enter") this.stopBubble(e);
        }}
      >
        <Form onSubmit={this.stopBubble}>
          <Modal.Header closeButton className="bg-warning">
            <Modal.Title>
              {this.props.Type === "Edit"
                ? "Edit Finished Good"
                : "Add Finished Good"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* Product row */}
            <Row className="g-2 align-items-center mb-2">
              <Col md={9}>
                <FloatingLabel label="Product Name / SKU *">
                  <Select
                    options={this.state.productOptions}
                    value={
                      this.state.itemId
                        ? this.state.productOptions.find(
                            (o) => o.value === this.state.itemId
                          )
                        : null
                    }
                    onChange={this.onProductChange}
                    isSearchable
                    placeholder=""
                  />
                </FloatingLabel>
              </Col>
              <Col md={3} className="text-end">
                <Button
                  onClick={(e) => {
                    this.stopBubble(e);
                    this.setState({ addProductModal: true });
                  }}
                >
                  New Product ?
                </Button>
              </Col>
            </Row>

            {/* Form rows */}
            <Row className="g-2">
              <Col md={12}>
                {/* <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm="3">
                    Remarks
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      name="remarks"
                      value={this.state.remarks}
                      onChange={(e) =>
                        this.setState({ remarks: e.target.value })
                      }
                    />
                  </Col>
                </Form.Group> */}

                {this.context.isSteelTraders() ? (
                  <>
                    <Form.Group as={Row} className="mb-2">
                      <Form.Label column sm="3">
                        Pieces *
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="pieces"
                          value={this.state.pieces}
                          onChange={(e) =>
                            this.setState({ pieces: e.target.value })
                          }
                          min="0"
                          step="1"
                          required
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-2">
                      <Form.Label
                        column
                        sm="3"
                      >{`QTY/WT in ${unitLabel} *`}</Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="qty"
                          value={this.state.qty}
                          onChange={(e) =>
                            this.setState({ qty: e.target.value })
                          }
                          min="0"
                          step="0.0001"
                          required
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2">
                      <Form.Label
                        column
                        sm="3"
                      >{`Purchase Price / ${unitLabel} *`}</Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="rate"
                          value={this.state.rate}
                          onChange={(e) =>
                            this.setState({ rate: e.target.value })
                          }
                          min="0"
                          step="0.01"
                          required
                        />
                      </Col>
                    </Form.Group>
                  </>
                ) : (
                  <>
                    <Form.Group as={Row} className="mb-2">
                      <Form.Label
                        column
                        sm="3"
                      >{`QTY/WT in ${unitLabel} *`}</Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="qty"
                          value={this.state.qty}
                          onChange={(e) =>
                            this.setState({ qty: e.target.value })
                          }
                          min="0"
                          step="0.0001"
                          required
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2">
                      <Form.Label
                        column
                        sm="3"
                      >{`selling Price / ${unitLabel} *`}</Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="mrp"
                          value={this.state.mrp}
                          onChange={(e) =>
                            this.setState({ mrp: e.target.value })
                          }
                          min="0"
                          step="0.01"
                          required
                        />
                      </Col>
                    </Form.Group>
                  </>
                )}
              </Col>
            </Row>

            {/* New Product modal */}
            {this.state.addProductModal && (
              <InventoryAddOrEditModal
                show
                Type="Add"
                onHide={() => {
                  this.setState(
                    { addProductModal: false },
                    this.loadProductOptions
                  );
                }}
                onSaved={() => {
                  // ask parent to remount so I re-read updated prods
                  this.props.onReloadMe?.();
                }}
                GetsInventories={this.props.GetsInventories || (() => {})}
                warehouse={this.props.warehouses || []}
                warehouseId={this.props.defaultWarehouseId}
                enforceWarehouse
              />
            )}
          </Modal.Body>

          <Modal.Footer className="bg-light">
            <Button
              variant="primary"
              size="lg"
              type="button"
              onClick={this.save}
            >
              Save
            </Button>
            <Button
              variant="danger"
              size="lg"
              type="button"
              onClick={(e) => {
                this.stopBubble(e);
                this.props.onHide();
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}
export class InventoryAddOrEditModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      showAllErrors: false, // after first submit, show everything invalid
      touched: {}, // per-field touched state
      product: {
        name: "",
        pieces: 1,
        productVariantType:
          this.context?.storeSettings?.defaultProductVariantType ?? 1,
        unit: this.context?.storeSettings?.defaultUnit || "piece",
        hsnCode: "",
        batchId: "",
        qualityId: "",
        subCategoryId: "",
        thickness: "",
        width: "",
        length: "",
        warehouseId: props.warehouseId || "",
      },
      mainCategoryId: "",
      errors: {},
    };
  }

  componentDidMount() {
    setTimeout(() => {
      const el = document.getElementById("inv-name");
      if (el) el.focus();
    }, 0);

    this.setState((s) => ({
      product: {
        ...s.product,
        productVariantType:
          this.context?.storeSettings?.defaultProductVariantType ??
          s.product.productVariantType,
        unit: this.context?.storeSettings?.defaultUnit || s.product.unit,
      },
    }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.warehouseId !== this.props.warehouseId) {
      this.setState((s) => ({
        product: { ...s.product, warehouseId: this.props.warehouseId || "" },
      }));
    }
  }

  // ---------- Helpers ----------
  stop = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
  };

  setField = (name, value) => {
    this.setState(
      (s) => ({
        product: { ...s.product, [name]: value },
      }),
      this.validate
    ); // live-validate
  };

  onBlur = (name) => {
    this.setState(
      (s) => ({
        touched: { ...s.touched, [name]: true },
      }),
      this.validate
    );
  };

  // Simple patterns/limits
  // HSN is often 4/6/8 digits; keep it permissive (digits up to 8)
  HSN_PATTERN = /^[0-9]{0,8}$/;

  validate = () => {
    const { product, mainCategoryId } = this.state;
    const errs = {};

    // Requireds
    if (!product.warehouseId) errs.warehouseId = "Warehouse is required.";
    if (!product.name || !product.name.trim())
      errs.name = "Product name is required.";
    if (!product.unit || !product.unit.trim()) errs.unit = "Unit is required.";

    // Categories (if you require them)
    if (!mainCategoryId) errs.mainCategoryId = "Main category is required.";
    if (!product.subCategoryId)
      errs.subCategoryId = "Sub category is required.";

    // Numeric constraints
    const nonNeg = (v) => v === "" || Number(v) >= 0;
    if (!nonNeg(product.pieces)) errs.pieces = "Pieces cannot be negative.";
    if (!nonNeg(product.thickness))
      errs.thickness = "Thickness cannot be negative.";
    if (!nonNeg(product.width)) errs.width = "Width cannot be negative.";
    if (!nonNeg(product.length)) errs.length = "Length cannot be negative.";

    // Length limits
    if ((product.name || "").length > 254)
      errs.name = "Name cannot exceed 254 characters.";
    if ((product.hsnCode || "").length > 8)
      errs.hsnCode = "HSN cannot exceed 8 digits.";
    if ((product.batchId || "").length > 64)
      errs.batchId = "Batch/Coil ID too long.";

    // Patterns
    if (product.hsnCode && !this.HSN_PATTERN.test(product.hsnCode))
      errs.hsnCode = "HSN must be up to 8 digits.";

    this.setState({ errors: errs });
    return Object.keys(errs).length === 0;
  };

  // ---------- Save ----------
  AddProductInDB = async () => {
    const ok = this.validate();
    if (!ok) {
      this.setState({ showAllErrors: true });
      return;
    }

    const tmpproduct = { ...this.state.product };
    tmpproduct.storeId = this.context.storeId;

    // Force warehouse from parent when provided
    tmpproduct.warehouseId = this.props.warehouseId ?? tmpproduct.warehouseId;

    // Optional steel-style suffix if dims provided
    const dimsProvided =
      tmpproduct.thickness || tmpproduct.width || tmpproduct.length;
    if (dimsProvided) {
      const suffix = ` ${tmpproduct.thickness || 0}mm X ${
        tmpproduct.width || 0
      }mm X ${tmpproduct.length || 0}mm`;
      tmpproduct.name = (tmpproduct.name || "").trim() + suffix;
    }

    try {
      this.setState({ saving: true });
      const res = await fetch(
        process.env.REACT_APP_API + "StoreManager/AddOrUpdateProduct/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(tmpproduct),
        }
      );

      if (res.status === 200) {
        // notify AddOrEditFinishedGoodItem so it can remount
        this.props.onSaved?.(tmpproduct);

        // refresh inventories/products so context.prods updates
        this.props.GetsInventories?.();
        this.context.GetAllProducts?.();

        // close only this modal
        this.props.onHide?.();
      } else {
        alert(
          "This product already exists or could not be saved. Code: " +
            res.status
        );
      }
    } catch (err) {
      alert("Exception. Try again later! " + (err?.message || err));
    } finally {
      this.setState({ saving: false });
    }
  };

  handleSubmit = (e) => {
    this.stop(e);
    this.AddProductInDB();
  };

  // UI: helper to decide when to show error for a field
  showErr = (name) =>
    this.state.errors[name] &&
    (this.state.touched[name] || this.state.showAllErrors);

  render() {
    const { show, onHide, Type, warehouse = [], enforceWarehouse } = this.props;
    const { product, errors, saving, mainCategoryId } = this.state;

    return (
      <div className="container">
        <Modal
          show={!!show}
          onHide={onHide}
          size="xl"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="productModal"
          onKeyDown={(e) => e.key === "Enter" && this.stop(e)}
        >
          <Form onSubmit={this.handleSubmit} noValidate>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title>
                {Type === "Edit" ? "Edit Product" : "Add Product to Inventory"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="show-grid">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  {/* Warehouse */}
                  <FloatingLabel label="Warehouse *" className="mb-3">
                    <Form.Select
                      name="warehouseId"
                      size="lg"
                      value={product.warehouseId}
                      onChange={(e) =>
                        this.setField("warehouseId", e.target.value)
                      }
                      onBlur={() => this.onBlur("warehouseId")}
                      required
                      disabled={!!enforceWarehouse}
                      isInvalid={!!this.showErr("warehouseId")}
                      className="text-start"
                    >
                      <option value=""></option>
                      {warehouse.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.warehouseId}
                    </Form.Control.Feedback>
                  </FloatingLabel>

                  {/* Name + Dimensions + Unit */}
                  <Row>
                    <Col md={5}>
                      <FloatingLabel label="Product Name *" className="mb-3">
                        <Form.Control
                          id="inv-name"
                          type="text"
                          size="lg"
                          name="name"
                          value={product.name}
                          onChange={(e) =>
                            this.setField("name", e.target.value)
                          }
                          onBlur={() => this.onBlur("name")}
                          isInvalid={!!this.showErr("name")}
                          maxLength={254}
                          placeholder=""
                          autoComplete="off"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                    {this.context.isSteelTraders() ? (
                      <>
                        <Col md={2}>
                          <FloatingLabel label="Thickness (mm)">
                            <Form.Control
                              type="number"
                              size="lg"
                              name="thickness"
                              value={product.thickness}
                              onChange={(e) =>
                                this.setField("thickness", e.target.value)
                              }
                              onBlur={() => this.onBlur("thickness")}
                              isInvalid={!!this.showErr("thickness")}
                              placeholder=""
                              min="0"
                              step="0.001"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.thickness}
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Col>
                        <Col md={2}>
                          <FloatingLabel label="Width (mm)">
                            <Form.Control
                              type="number"
                              size="lg"
                              name="width"
                              value={product.width}
                              onChange={(e) =>
                                this.setField("width", e.target.value)
                              }
                              onBlur={() => this.onBlur("width")}
                              isInvalid={!!this.showErr("width")}
                              placeholder=""
                              min="0"
                              step="0.001"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.width}
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Col>
                        <Col md={2}>
                          <FloatingLabel label="Length (mm)">
                            <Form.Control
                              type="number"
                              size="lg"
                              name="length"
                              value={product.length}
                              onChange={(e) =>
                                this.setField("length", e.target.value)
                              }
                              onBlur={() => this.onBlur("length")}
                              isInvalid={!!this.showErr("length")}
                              placeholder=""
                              min="0"
                              step="0.001"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.length}
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}

                    <Col md={1}>
                      <FloatingLabel label="Unit *" className="mb-3">
                        <Form.Select
                          type="text"
                          name="unit"
                          size="lg"
                          value={product.unit}
                          placeholder=""
                          required
                          align="center"
                          className="text-start"
                          autoComplete="off"
                          onChange={(e) =>
                            this.setField("unit", e.target.value)
                          }
                          onBlur={() => this.onBlur("unit")}
                          isInvalid={!!this.showErr("unit")}
                        >
                          <option value=""></option>
                          <option value="piece">piece</option>
                          <option value="gram">gram</option>
                          <option value="kg">kg</option>
                          <option value="ton">ton</option>
                          <option value="ml">ml</option>
                          <option value="liter">liter</option>
                          <option value="meter">meter</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.unit}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <FloatingLabel label="Remarks" className="mb-3">
                    <Form.Control
                      type="text"
                      id="remarks"
                      size="lg"
                      name="remarks"
                      maxLength={99}
                      value={product.remarks || ""}
                      placeholder=""
                      autoComplete="off"
                      onChange={(e) => this.setField("remarks", e.target.value)}
                      // onChange={this.handleInputChange}
                    />
                  </FloatingLabel>

                  {/* HSN / Batch / VariantType */}
                  <Row className="g-3 mb-3">
                    <Col md={2}>
                      <FloatingLabel
                        label={
                          this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS
                            ? "SCNO"
                            : "InternalId"
                        }
                      >
                        <Form.Control
                          type="text"
                          size="lg"
                          name="internalId"
                          value={product.internalId}
                          onChange={(e) =>
                            this.setField("internalId", e.target.value)
                          }
                          onBlur={() => this.onBlur("internalId")}
                          isInvalid={!!this.showErr("internalId")}
                          maxLength={64}
                          placeholder=""
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.internalId}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                    <Col md={2}>
                      <FloatingLabel
                        label={
                          this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS
                            ? "Coil ID"
                            : "BatchId"
                        }
                      >
                        <Form.Control
                          type="text"
                          size="lg"
                          name="batchId"
                          value={product.batchId}
                          onChange={(e) =>
                            this.setField("batchId", e.target.value)
                          }
                          onBlur={() => this.onBlur("batchId")}
                          isInvalid={!!this.showErr("batchId")}
                          maxLength={64}
                          placeholder=""
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.batchId}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                    <Col md={2}>
                      <FloatingLabel label="HSN Code">
                        <Form.Control
                          type="text"
                          size="lg"
                          name="hsnCode"
                          value={product.hsnCode}
                          onChange={(e) =>
                            this.setField("hsnCode", e.target.value)
                          }
                          onBlur={() => this.onBlur("hsnCode")}
                          isInvalid={!!this.showErr("hsnCode")}
                          inputMode="numeric"
                          maxLength={8}
                          placeholder=""
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.hsnCode}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                    <Col md={2}>
                      <FloatingLabel
                        label={
                          this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS
                            ? "Test Report No"
                            : "QualityId"
                        }
                      >
                        <Form.Control
                          type="text"
                          size="lg"
                          name="qualityId"
                          value={product.qualityId}
                          onChange={(e) =>
                            this.setField("qualityId", e.target.value)
                          }
                          onBlur={() => this.onBlur("qualityId")}
                          isInvalid={!!this.showErr("qualityId")}
                          maxLength={64}
                          placeholder=""
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.qualityId}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                    <Col md={2}>
                      <FloatingLabel
                        label="Product Variant Type *"
                        className="mb-3"
                      >
                        <Form.Select
                          name="productVariantType"
                          value={product.productVariantType}
                          autoComplete="off"
                          onChange={(e) =>
                            this.setField("productVariantType", e.target.value)
                          }
                        >
                          <option value={1}>Single</option>
                          <option value={2}>MultipleType</option>
                          <option value={3}>SteelType</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>

                  {/* Categories */}
                  <Row>
                    <Col>
                      <FloatingLabel label="Main Category *" className="mb-1">
                        <Form.Select
                          name="mainCategoryId"
                          value={mainCategoryId}
                          required
                          onChange={(e) => {
                            const v = e.target.value;
                            this.setState(
                              (s) => ({
                                mainCategoryId: v,
                                product: { ...s.product, subCategoryId: "" },
                              }),
                              this.validate
                            );
                          }}
                          onBlur={() => this.onBlur("mainCategoryId")}
                          isInvalid={!!this.showErr("mainCategoryId")}
                        >
                          <option value="">-- Select Main Category --</option>
                          {this.context.mainCategories.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                              {cat.name}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.mainCategoryId}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                    <Col>
                      <FloatingLabel label="Sub Category *" className="mb-1">
                        <Form.Select
                          name="subCategoryId"
                          value={product.subCategoryId}
                          required
                          onChange={(e) =>
                            this.setField("subCategoryId", e.target.value)
                          }
                          onBlur={() => this.onBlur("subCategoryId")}
                          isInvalid={!!this.showErr("subCategoryId")}
                        >
                          <option value="">-- Select Sub Category --</option>
                          {this.context.subCategories
                            .filter(
                              (sub) => sub.mainCategoryId === mainCategoryId
                            )
                            .map((sub) => (
                              <option key={sub.id} value={sub.id}>
                                {sub.name}
                              </option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.subCategoryId}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <Button
                variant="primary"
                size="lg"
                type="submit"
                disabled={saving}
                onClick={this.handleSubmit}
              >
                {saving ? "Saving..." : Type === "Edit" ? "Update" : "Add"}
              </Button>
              <Button
                variant="danger"
                size="lg"
                onClick={(e) => {
                  this.stop(e);
                  onHide?.();
                }}
              >
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export function ManufacturingDashboard({ show, onHide }) {
  const { storeId } = useContext(CartContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);

  useEffect(() => {
    if (show) loadAnalytics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const loadAnalytics = async () => {
    if (!storeId) {
      setError("No store selected");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const url = `${process.env.REACT_APP_API}Manufacturing/AnalyticsSummary/${storeId}`;
      const res = await axios.get(url);
      const data = res.data || {};

      // Normalize defensive defaults
      const norm = {
        totalOrders: data.totalOrders ?? 0,
        statusCounts: data.statusCounts ?? {},
        inProgress: data.inProgress ?? data.inprogress ?? 0,
        completed: data.completed ?? 0,
        cancelled: data.cancelled ?? 0,
        finishedGoodsProduced: data.finishedGoodsProduced ?? 0,
        rawMaterialsDeliveredQty: data.rawMaterialsDeliveredQty ?? 0,
        topRawMaterials: Array.isArray(data.topRawMaterials)
          ? data.topRawMaterials
          : data.toprawmaterials ?? [],
        last6Months: Array.isArray(data.last6Months)
          ? data.last6Months
          : data.last6Months ?? [],
      };

      setAnalyticsData(norm);
    } catch (err) {
      console.error("Failed to load analytics:", err);
      setError("Failed to load analytics");
      setAnalyticsData(null);
    } finally {
      setLoading(false);
    }
  };

  // Build doughnut data from statusCounts object
  const buildStatusDoughnut = (statusCounts) => {
    if (!statusCounts || typeof statusCounts !== "object") {
      return {
        data: {
          labels: ["No data"],
          datasets: [{ data: [1], backgroundColor: ["#e9ecef"] }],
        },
      };
    }

    const statusNames = {
      1: "NewRequest",
      2: "MakingInProgress",
      3: "MakingComplete",
      4: "QualityCheckComplete",
      5: "DeliveredToWarehouse",
      6: "AddedToInventory",
      7: "Cancelled",
    };

    const labels = [];
    const values = [];
    const bg = [];

    Object.keys(statusCounts).forEach((k) => {
      const count = Number(statusCounts[k] ?? 0);
      if (count <= 0) return;
      labels.push(statusNames[k] ?? `Status ${k}`);
      values.push(count);
      bg.push(
        [
          "#4e73df",
          "#1cc88a",
          "#36b9cc",
          "#f6c23e",
          "#e74a3b",
          "#858796",
          "#6f42c1",
        ][(Number(k) - 1) % 7]
      );
    });

    if (values.length === 0) {
      return {
        data: {
          labels: ["No data"],
          datasets: [{ data: [1], backgroundColor: ["#e9ecef"] }],
        },
      };
    }

    return {
      data: {
        labels,
        datasets: [{ data: values, backgroundColor: bg }],
      },
    };
  };

  // Build monthly bar chart
  const buildMonthlyBar = (last6Months) => {
    const labels = [];
    const orders = [];
    const produced = [];

    (last6Months || []).forEach((m) => {
      labels.push(m.date ?? m.Date ?? m.Label ?? m.label ?? "");
      orders.push(Number(m.orders ?? m.Orders ?? 0));
      produced.push(Number(m.producedQty ?? m.ProducedQty ?? m.produced ?? 0));
    });

    const data = {
      labels,
      datasets: [
        {
          label: "Orders",
          backgroundColor: "#4e73df",
          data: orders,
          yAxisID: "yOrders",
        },
        {
          label: "Produced Qty",
          backgroundColor: "#f78fb3",
          data: produced,
          yAxisID: "yProduced",
        },
      ],
    };

    const options = {
      responsive: true,
      scales: {
        yOrders: {
          type: "linear",
          position: "left",
          beginAtZero: true,
        },
        yProduced: {
          type: "linear",
          position: "right",
          beginAtZero: true,
          grid: { drawOnChartArea: false },
        },
      },
      plugins: {
        legend: { position: "bottom" },
      },
    };

    return { data, options };
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      centered
      dialogClassName="modal-90w"
    >
      <Modal.Header closeButton>
        <Modal.Title>Manufacturing Analytics</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" /> <div>Loading analytics...</div>
          </div>
        ) : error ? (
          <Alert variant="danger">{error}</Alert>
        ) : !analyticsData ? (
          <Alert variant="warning">No analytics data</Alert>
        ) : (
          <>
            <Row className="mb-3 g-3">
              <Col>
                <Card className="p-2 text-center">
                  <small className="text-muted">Total Orders</small>
                  <h4 className="mb-0">{analyticsData.totalOrders}</h4>
                </Card>
              </Col>
              <Col>
                <Card className="p-2 text-center">
                  <small className="text-muted">In Progress</small>
                  <h4 className="mb-0">{analyticsData.inProgress}</h4>
                </Card>
              </Col>
              <Col>
                <Card className="p-2 text-center">
                  <small className="text-muted">Completed</small>
                  <h4 className="mb-0">{analyticsData.completed}</h4>
                </Card>
              </Col>
              <Col>
                <Card className="p-2 text-center">
                  <small className="text-muted">Finished Goods Produced</small>
                  <h4 className="mb-0">
                    {Number(
                      analyticsData.finishedGoodsProduced ?? 0
                    ).toLocaleString()}
                  </h4>
                </Card>
              </Col>
            </Row>

            <Row className="g-3">
              <Col md={6}>
                <Card className="p-2" style={{ minHeight: 300 }}>
                  <Card.Title style={{ fontSize: "0.95rem" }}>
                    Status Distribution
                  </Card.Title>
                  <div style={{ height: 230 }}>
                    <Doughnut
                      {...buildStatusDoughnut(analyticsData.statusCounts)}
                    />
                  </div>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="p-2" style={{ minHeight: 300 }}>
                  <Card.Title style={{ fontSize: "0.95rem" }}>
                    Last 6 Months — Orders / Produced
                  </Card.Title>
                  <div style={{ height: 230 }}>
                    <Bar {...buildMonthlyBar(analyticsData.last6Months)} />
                  </div>
                </Card>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Card>
                  <Card.Header>
                    Top Raw Materials (by qty delivered)
                  </Card.Header>
                  <Table striped bordered size="sm" className="mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: 50 }}>#</th>
                        <th>Raw Material</th>
                        <th style={{ width: 150 }}>Qty Delivered</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(analyticsData.topRawMaterials) &&
                      analyticsData.topRawMaterials.length > 0 ? (
                        analyticsData.topRawMaterials.map((r, idx) => (
                          <tr key={r.rawMaterialId ?? idx}>
                            <td>{idx + 1}</td>
                            <td>
                              {r.rawMaterialName ??
                                r.RawMaterialName ??
                                "Unknown"}
                            </td>
                            <td>
                              {Number(
                                r.totalQty ?? r.TotalQty ?? 0
                              ).toLocaleString()}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center text-muted">
                            No data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={loadAnalytics} disabled={loading}>
          {loading ? "Refreshing..." : "Refresh Analytics"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
